
const shortcuts = new Map();

const handleKeyDown = (event) => {
    if (!event.key) {
        return;
    }
    const key = event.key.toLowerCase();
    const combo = `${event.altKey ? 'alt+' : ''}${event.ctrlKey ? 'ctrl+' : ''}${event.shiftKey ? 'shift+' : ''}${key}`;

    if (shortcuts.has(combo)) {
        event.preventDefault();
        shortcuts.get(combo)();
    }
};

const addShortcut = (combo, callback) => {
    shortcuts.set(combo.toLowerCase(), callback);
};

const removeShortcut = (combo) => {
    shortcuts.delete(combo.toLowerCase());
};

const removeAll = () => {
    shortcuts.clear();
};

document.addEventListener('keydown', handleKeyDown);

const shortcutManager = {
    addShortcut,
    removeShortcut,
    removeAll,
};

export default shortcutManager;